// ============================================================================
// COMMON STATUS ENDPOINTS
// ============================================================================
// Endpoint definitions for common/statuses — reads from common.tbl_status

import { buildEndpoint, buildEndpointWithQuery } from './base.endpoints';

const BASE_PATH = '/common/statuses';

export const statusEndpoints = {
  /** GET /api/v1/common/statuses?statusType=GENERAL */
  getByType: (statusType: string = 'GENERAL') =>
    buildEndpointWithQuery(buildEndpoint(BASE_PATH), { statusType }),
} as const;

export default statusEndpoints;
